// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2zaIb","label":"Category_label__2XHrm","content":"Category_content__1bhzj","header":"Category_header__1wy4k","location":"Category_location__3oK1e"};